import { AgentTaskStatus, type AgentTask } from "@forgepoint/shared";

/** Separates actionable assignments from other active work and future steps. */
export function getThreadTaskGroups(tasks: AgentTask[], userId?: string) {
  const active = tasks.filter(
    (task) => task.status === AgentTaskStatus.IN_PROGRESS,
  );
  const assigned = active.filter((task) =>
    task.owners.some((owner) => owner.type === "userId" && owner.id === userId),
  );
  const others = active.filter((task) => !assigned.includes(task));
  const upcoming = tasks.filter(
    (task) => task.status === AgentTaskStatus.PENDING,
  );
  return { assigned, others, upcoming, total: active.length + upcoming.length };
}
